export const LOGIN_ROUTE = "/corporate-admin";
export const FORGOT_ROUTE = "/corporate-admin/forgot-password";
export const DASHBOARD_ROUTE = "/corporate-admin/dashboard";
export const OTP_ROUTE = "/corporate-admin/otps";
export const CREATE_ADMIN_ROUTE = "/corporate-admin/admins";
export const GALLERY_ROUTE = "/corporate-admin/gallery";

export const PROFILE_ROUTE = "/corporate-admin/otps";
export const ROUTE1 = "/corporate-admin/otps";
export const COMMON1 = "/corporate-admin/common";
export const COMMON2 = "/corporate-admin/common2";
export const COMMON3 = "/corporate-admin/common3";
export const COMMON4 = "/corporate-admin/common4";
export const COMMON5 = "/corporate-admin/common5";
export const COMMON6 = "/corporate-admin/common6";

export function  PRODUCT_BY_EXCEL(id){
   return `/corporate-admin/excel-products/${id}`;
}




export const PRODUCT_ROUTE = "/corporate-admin/menu-pricing";
export const MEALS_ROUTES = "/corporate-admin/meals";
export const REVENUE_ROUTES = "/corporate-admin/revenues";
export const TOP_SELLING_ROUTES = "/corporate-admin/top-selling-products";
export const EMP_ROUTES = "/corporate-admin/emp-feed";
export const EMP_USAGE_ROUTES = "/corporate-admin/no-of-app-users";




export const CAFETERIA_INVENTORY_ROUTE ="/corporate-admin/cafeteria-inventory"
export const VENDOR_ROUTE ="/corporate-admin/vendor"
export const VENDOR_MANAGER_ROUTE ="/corporate-admin/vendor-manager"
export const VENDOR_COMPLIANCE_ROUTE ="/corporate-admin/vendor-compliance"